"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _index = _interopRequireDefault(require("./index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecretsRoutes = function SecretsRoutes(_ref) {
  var match = _ref.match;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(match.url),
    component: _index.default
  }));
};

SecretsRoutes.propTypes = {
  history: _propTypes.default.any,
  match: _propTypes.default.any
};
var _default = SecretsRoutes;
exports.default = _default;